import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  getAllOrdersByTrackingNo,
  getSingleOrder,
} from "../../firebase/firebase.utils";
import man from "../products/physical/plus image.jpeg";
import {
  getOrderTrackingResultRedux,
  getSingleOrderRedux,
} from "../../actions";
import FullPageLoader from "./fullPageLoader";
export class SearchedOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      imageUrl: man,
      loader: true,
    };
  }

  componentDidMount = async () => {
    let order = await getSingleOrder(this.props.match.params.orderId);

    this.setState({
      order: order,
      loader: false,
    });
  };

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    if (this.props.match.params.orderId != nextProps.match.params.orderId) {
      this.setState({
        loader: true,
      });
      let order = await getSingleOrder(nextProps.match.params.orderId);

      this.setState({
        order,
        loader: false,
      });
    }
  };

  timeout = (delay) => {
    return new Promise((res) => setTimeout(res, delay));
  };
  toWait = () => {
    this.timeout(1000);
  };

  getTotal = (productObj) => {
    const { currency } = this.props;
    let totalRmbAmount = 0;

    if (productObj) {
      productObj.items.map((item) => {
        item.skus.map((sku) => {
          totalRmbAmount += parseFloat(
            (sku.price * sku.totalQuantity) /
              (productObj.currency ? productObj.currency : currency.taka)
          );

          console.log(
            parseFloat(
              (sku.price * sku.totalQuantity) /
                (productObj.currency ? productObj.currency : currency.taka)
            )
          );
        });
      });
    }
    return totalRmbAmount;
  };
  singleProductTotal = (product) => {
    let total = parseInt(this.getPrice2(product)) * product.quantity;
    return total;
  };
  getPrice2 = (product) => {
    if (product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return product.selectedVariation.price;
      } else {
        return product.selectedVariation.salePrice;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return product.product.price;
        } else {
          return product.product.salePrice;
        }
      } else {
        return 0;
      }
    }
  };
  getPrice3 = (product) => {
    if (product.selectedVariation.id) {
      if (product.selectedVariation.salePrice == 0) {
        return "";
      } else {
        return `৳ ${product.selectedVariation.price}`;
      }
    } else {
      if (product.product) {
        if (product.product.salePrice == 0) {
          return "";
        } else {
          return `৳ ${product.product.price}`;
        }
      } else {
        return 0;
      }
    }
  };

  render() {
    const { orderTracking, currency } = this.props;
    const { order } = this.state;
    let deliveryAddress = null;
    if (
      order &&
      order.currentUser &&
      order.currentUser.address &&
      order.currentUser.address.length > 0
    ) {
      deliveryAddress = order.currentUser.address.find(
        (address) => address.defaultShipping
      );
    } else if (
      order &&
      order.guest &&
      order.guest.address &&
      order.guest.address.length > 0
    ) {
      deliveryAddress = order.guest.address.find(
        (address) => address.defaultShipping
      );
    }

    let totalPaid = 0;
    if (order && order.payments && order.payments.length > 0) {
      order.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    let amountPayable = 0;
    if (order) {
      amountPayable =
        order &&
        order.subTotal +
          order.deliveryCharge -
          order.discountApplied -
          (order.couponApplied ? order.couponApplied.discount : 0) -
          (order.finalDiscount ? order.finalDiscount : 0);
    }
    if (order) {
      return (
        <div style={{ paddingTop: 30 }}>
          {this.state.loader && <FullPageLoader />}
          <div className="modal-content" style={{ top: 10, margin: "auto" }}>
            <div
              className="modal-header"
              style={{
                backgroundColor: "rgb(251, 148, 4)",
                paddingTop: 20,
                paddingBottom: 20,
              }}
            >
              <div
                className="modal-title"
                style={{
                  fontWeight: "bold",
                  fontSize: 17,
                  color: "white",
                }}
                id="exampleModalLabel"
              >
                Order Id: {order && order.id}
              </div>
            </div>
            <div className="modal-body">
              <div style={{ padding: "10px 15px" }}></div>
              <div
                className="row"
                style={{
                  marginBottom: 10,
                  borderBottom: "1px solid gainsboro",
                }}
              >
                <div className="col">
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                      color: "gray",
                    }}
                  >
                    Order Information
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Order Id:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {" "}
                      #{order && order.id}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Ordered at:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {" "}
                      {order &&
                        new Date(Number(order.date)).toLocaleDateString()}
                      {"  "}
                      {order &&
                        new Date(Number(order.date)).toLocaleTimeString()}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Order Status:{" "}
                    <span
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        color: "white",
                        padding: "3px 7px",
                        borderRadius: 5,
                        backgroundColor: order
                          ? order.orderStatus == "Processing"
                            ? "#0f0fd9"
                            : order.orderStatus == "Confirmed"
                            ? "orange"
                            : order.orderStatus == "Packing"
                            ? "darkorange"
                            : order.orderStatus == "On the way"
                            ? "green"
                            : order.orderStatus == "Delivered"
                            ? "green"
                            : order.orderStatus == "Cancelled"
                            ? "red"
                            : "white"
                          : "white",
                        textAlign: "center",
                        fontSize: 12,
                      }}
                    >
                      {order && order.orderStatus}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Subtotal:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {" "}
                      ৳{order && order.subTotal}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Delivery Charge:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {" "}
                      ৳ {(order && order.deliveryCharge) || "0"}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Discount Applied:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {" "}
                      ৳ {(order && order.discountApplied) || "0"}
                    </span>
                  </div>
                  {order && order.couponApplied && (
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Coupon Applied{" "}
                      <span
                        style={{
                          color: "rgb(251, 148, 4)",
                          fontWeight: "bold",
                          fontSize: 12,
                        }}
                      >
                        {" "}
                        ({order.couponApplied.name})
                      </span>
                      :{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {" "}
                        ৳ {(order && order.couponApplied.discount) || 0}
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Amount Payable:{" "}
                    <span style={{ fontWeight: "bold" }}>
                      ৳{" "}
                      {order &&
                        order.subTotal +
                          order.deliveryCharge -
                          order.discountApplied -
                          (order.couponApplied
                            ? order.couponApplied.discount
                            : 0)}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Final Discount:{" "}
                    <span style={{ fontWeight: "bold" }}>
                      ৳ {order && order.finalDiscount ? order.finalDiscount : 0}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Amount Payable{" "}
                    <span style={{ fontSize: 11 }}>(after discount)</span>
                    <span style={{ fontWeight: "bold" }}>
                      ৳{" "}
                      {order &&
                        order.subTotal +
                          order.deliveryCharge -
                          order.discountApplied -
                          (order.couponApplied
                            ? order.couponApplied.discount
                            : 0) -
                          (order.finalDiscount ? order.finalDiscount : 0)}
                    </span>
                  </div>
                  {order && order.cancelNote && (
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Cancellation Note:{" "}
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: 13,
                          color: "gray",
                        }}
                      >
                        {order.cancelNote}
                      </span>
                    </div>
                  )}
                </div>
                <div className="col">
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                      color: "gray",
                    }}
                  >
                    Schedule Information
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Order Date:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order &&
                        new Date(Number(order.date)).toLocaleDateString()}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Confirmed Date:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order &&
                        order.confirmedDate &&
                        new Date(
                          Number(order.confirmedDate)
                        ).toLocaleDateString()}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Packing Date:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order &&
                        order.packingDate &&
                        new Date(
                          Number(order.packingDate)
                        ).toLocaleDateString()}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Delivered Date:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order &&
                        order.deliveredDate &&
                        new Date(
                          Number(order.deliveredDate)
                        ).toLocaleDateString()}
                    </span>
                  </div>
                  {order && order.cancelledDate && (
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                      }}
                    >
                      Cancelled Date:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {order &&
                          order.cancelledDate &&
                          new Date(
                            Number(order.cancelledDate)
                          ).toLocaleDateString()}
                      </span>
                    </div>
                  )}
                  {order && order.orderNote && (
                    <div
                      style={{
                        padding: 10,
                        fontWeight: "bold",
                        paddingTop: 0,
                        marginTop: 30,
                      }}
                    >
                      Order note:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {order && order.orderNote}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                      color: "gray",
                    }}
                  >
                    Customer Information
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Customer Id:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order && order.currentUser.uid}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Customer Name:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order && order.currentUser.displayName}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Customer Email:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order && order.currentUser.email}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Customer Mobile No:{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {order && order.currentUser.mobielNumber}
                    </span>
                  </div>
                </div>
                <div className="col">
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                      color: "gray",
                    }}
                  >
                    Delivery Information
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Name :{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {deliveryAddress && deliveryAddress.fullName}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Mobile :{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {deliveryAddress && deliveryAddress.mobileNo}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Address :{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {deliveryAddress && deliveryAddress.address}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    District :{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {deliveryAddress && deliveryAddress.district}
                    </span>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      fontWeight: "bold",
                      paddingTop: 0,
                    }}
                  >
                    Division :{" "}
                    <span style={{ fontWeight: "lighter" }}>
                      {deliveryAddress && deliveryAddress.division}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 30 }}></div>
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <td style={{ fontWeight: "bold" }}>Product Image</td>
                    <td style={{ fontWeight: "bold" }}>Product Name</td>
                    <td style={{ fontWeight: "bold" }}>Product Price</td>
                    <td style={{ fontWeight: "bold" }}>Total Quantity</td>
                    <td style={{ fontWeight: "bold" }}>
                      Available Stock <br />{" "}
                      <span style={{ fontSize: 12, color: "gray" }}>
                        at the time of order
                      </span>
                    </td>
                    <td style={{ fontWeight: "bold" }}>Total Price</td>
                  </tr>
                </thead>
                <tbody>
                  {order &&
                    order.orders.map((order) => (
                      <tr key={order.id}>
                        <td>
                          <img
                            style={{ height: 70, width: 70 }}
                            src={
                              order.selectedVariation &&
                              order.selectedVariation.id &&
                              order.selectedVariation.pictures &&
                              order.selectedVariation.pictures.length > 0
                                ? order.selectedVariation.pictures[0]
                                : order.product.pictures[0]
                            }
                          />
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div style={{ fontWeight: "bold" }}>
                              {order.product.name.slice(0, 50)}...
                            </div>
                            {order.product.selectedCategories &&
                              order.product.selectedCategories.length > 0 &&
                              order.product.selectedCategories
                                .slice(0, 2)
                                .map((cat, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      fontSize: 14,
                                      color: "#444",
                                    }}
                                  >
                                    {cat.name}
                                  </div>
                                ))}

                            <div style={{ marginTop: 6 }}>
                              {order.selectedVariation &&
                                order.selectedVariation.id &&
                                order.selectedVariation.combination.map(
                                  (comb, index) => (
                                    <div key={index}>
                                      {order.product.savedAttributes.find(
                                        (attr) => attr.id == comb.parentId
                                      )
                                        ? order.product.savedAttributes.find(
                                            (attr) => attr.id == comb.parentId
                                          ).name
                                        : ""}
                                      : {comb.name}
                                    </div>
                                  )
                                )}
                            </div>
                            <div>
                              Total:৳ {this.singleProductTotal(order)} (
                              {order.quantity}pc)
                            </div>
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            {" "}
                            <div
                              style={{
                                fontSize: 13,
                                textDecorationLine: "line-through",
                                color: "gray",
                              }}
                            >
                              {this.getPrice3(order)}{" "}
                            </div>
                            <div
                              style={{
                                color: "black",
                                fontSize: 13,
                                fontWeight: "bold",
                              }}
                            >
                              ৳ {this.getPrice2(order)}
                            </div>
                          </div>
                        </td>
                        <td>{order.quantity}Pc</td>
                        <td>
                          {order.selectedVariation &&
                          order.selectedVariation.inventory
                            ? order.selectedVariation.inventory
                            : order.product.inventory}
                          Pc
                        </td>

                        <td style={{ fontWeight: "bold" }}>
                          ৳ {this.singleProductTotal(order)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      );
    } else {
      this.toWait();
      return (
        <div className="col-sm-12" style={{ marginTop: "10rem" }}>
          {this.state.loader && <FullPageLoader />}
          <div className="card">
            <div className="card-header">
              {!this.state.loader && (
                <h5>দুঃখিত এই অর্ডারটি খুজে পাওয়া যাচ্ছে না।</h5>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    orderTracking: state.orders.orderTracking,
    currency: state.users.currency,
    employees: state.employees.employees,
  };
};
export default withRouter(
  connect(mapStateToProps, { getSingleOrderRedux })(SearchedOrder)
);
